var $ffb2f77741c566ee$exports = {};
$ffb2f77741c566ee$exports = {
    "collapse": `Sutraukti`,
    "expand": `I\u{161}skleisti`
};


export {$ffb2f77741c566ee$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
